import React from 'react';
import { useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling

const CancellationPolicy = () => {
  const { lang } = useParams();
  const cancellationHtml = `
   <div dir="rtl">
     <h1>מדיניות ביטולים — SeegSoog.com</h1>
    <p><strong>תאריך כניסה לתוקף:</strong> 11 בדצמבר, 2025</p>
    <p>SeegSoog.com מופעלת על ידי חברת לוג-אין הבית החכם בע"מ, מספר ח.פ. 514147305, ישראל. מדיניות הביטולים הזו חלה על פעילות חברת לוג-אין הבית החכם בע"מ באתר SeegSoog.com.</p>

    <h2>1. גישה חופשית</h2>
    <p>ההרשמה והשימוש בתכונות בסיסיות (כגון עיון במודעות, שמירת נכסים) הם בחינם. ביטול חשבונך אינו כרוך בחיובים או בהחזרים כספיים.</p>

    <h2>2. מודעות מקודמות</h2>
    <ul>
      <li>ניתן לקדם מודעות דרך דף עריכת הנכס.</li>
      <li>קידום דורש תשלום והופך לפעיל באופן מיידי.</li>
      <li><strong>כל מכירות הקידום הן סופיות.</strong> לא יינתנו החזרים לאחר קידום המודעה.</li>
    </ul>

    <h2>3. דוחות בתשלום</h2>
    <ul>
      <li>דוחות הנרכשים דרך הפלטפורמה נשלחים בדוא"ל או ישירות לחשבונך.</li>
      <li><strong>לאחר שליחת דוח, העסקה סופית ואינה ניתנת להחזר.</strong></li>
      <li>במקרה של בעיות טכניות במשלוח, יש לפנות לתמיכה לקבלת סיוע.</li>
    </ul>

    <h2>4. רכישת לידים (לספקים)</h2>
    <ul>
      <li>ספקים יכולים לרכוש לידים ליצירת קשר עם משקיעים פוטנציאליים.</li>
      <li>ניתן לבקש החזר עבור ליד שנרכש, בצורת קרדיטים בפלטפורמה, תוך 72 שעות אם הליד אינו תקין. ליד נחשב לא תקין אם לא ניתן ליצור קשר באמצעות <strong>גם</strong> הדוא"ל ו<strong>גם</strong> מספר הטלפון שסופקו.</li>
      <li>כל בקשות ההחזר כפופות לבדיקה ואישור לפי שיקול דעתנו.</li>
    </ul>

    <h2>5. מחיקת מודעה וחשבון</h2>
    <ul>
      <li>ספקים יכולים למחוק או לבטל פרסום של מודעות בכל עת, אך הדבר לא יזכה בהחזר עבור קידומים פעילים או דוחות.</li>
      <li>מחיקת חשבון מסירה את הגישה לכל התכונות והנתונים, ללא החזר על שירותים ששולמו בעבר.</li>
    </ul>

    <h2>6. סיום עקב הפרות</h2>
    <p>חשבונות או מודעות המפרים את <a href="/${lang}/terms-of-use">תנאי השימוש</a> שלנו עשויים להיות מושעים או מבוטלים. במקרים כאלה לא יינתנו החזרים.</p>

    <h2>7. פתרון סכסוכים</h2>
    <p>לחריגים או חששות בנוגע לביטולים, אנא השתמשו בדף <a href="/${lang}/contact-us">צור קשר</a> שלנו. אנו נבחן את פנייתכם בקפידה.</p>
   </div>
  `;

  return (
    <div className="legal-page-container">
      <div className="legal-content" dangerouslySetInnerHTML={{ __html: cancellationHtml }} />
    </div>
  );
};

export default CancellationPolicy;
